import { CLOSED_SALESFORCE_CASE_STATUSES } from 'constants/salesforceCases';

export const isActiveCase = ({ status }) => !CLOSED_SALESFORCE_CASE_STATUSES.includes(status);

export const getCasesCounts = (cases) => ({
  total: cases.length,
  active: cases.filter(isActiveCase).length
});
